import React from "react";
import { Outlet, Navigate } from "react-router-dom";

const AuthRoutes = ({ isAuthenticated }) => {
  return isAuthenticated ? <Outlet /> : <Navigate to="/" />  
};

export default AuthRoutes;
